import AccountModule, { AccountState } from '@/modules/Account/store';
import AuthModule, { AuthState } from '@/modules/Auth/store';
import ContactModule, { ContactState } from '@/modules/Contact/store';
import DemandeDevisModule, { DemandeDevisState } from '@/modules/DemandeDevis/store';
import DemandeInterventionModule, { SuiviDemandeInterventionState } from '@/modules/DemandeIntervention/store';
import DevisModule, { SuiviDevisState } from '@/modules/Devis/store';
import ErrorToasterModule, { ErrorToasterState } from '@/modules/ErrorToaster/store';
import EstimateModule, { EstimateRequestState } from '@/modules/Estimate/store';
import HomeModule, { HomeModuleState } from '@/modules/Home/store';
import InterventionModule, { DemandeInterventionState } from '@/modules/Intervention/store';
import PreventifModule, { PreventifModuleState } from '@/modules/Preventif/store';
import SiteListModule, { SiteListState } from '@/modules/SiteList/store';
import SuiviFacturesModule, { SuiviFacturesModuleState } from '@/modules/SuiviFactures/store';
import SuiviInterventionModule, { SuiviInterventionState } from '@/modules/SuiviInterventions/store';
import SuiviInterventionPreventiveModule, {
    SuiviInterventionPreventiveState
} from '@/modules/SuiviInterventionsPreventives/store';
import SuiviReclamationModule, { SuiviReclamationState } from '@/modules/SuiviReclamation/store';
import DocumentReglementaireModule, { DocumentReglementaireState } from '@/modules/DocumentReglementaire/store';
import OptionsSuiviInterventionModule, {
    OptionsSuiviInterventionState
} from '@/modules/OptionsSuiviInterventions/store';
import PreavisInterventionModule, { PreavisInterventionState } from '@/modules/PreavisIntervention/store';
import MonCompteModule, { MonCompteState } from '@/modules/MonCompte/store';
import { createStore } from 'vuex';
import NFCModule, { NFCState } from '@/modules/Administrative/store';
import RapportASignerModule, { RapportASignerState } from '@/modules/RapportASigner/store';
import SuccessToasterModule, { SuccessToasterState } from '@/modules/SuccessToaster/store';
import RapportModule, { RapportState } from '@/modules/Rapport/store';
import CompteurModule, { CompteurState } from '@/modules/Outils/store';
import AuthenticationModule, { AuthenticationState } from '@/store';
import NoteReclamationModule, { NoteReclamationState } from '@/modules/NoteReclamation/store';
import MenuModule, { MenuState } from '@/components/layout/store';
import DashboardModule, { DashboardFournisseurState } from '@/modules/DashboardFournisseur/store';
import FactureFournisseurModule, { FactureFournisseurState } from '@/modules/FacturesFournisseurs/store';
import ReglementFournisseurModule, { ReglementFournisseurState } from '@/modules/ReglementsFournisseurs/store';
import SatisfactionModule, { SatisfactionState } from '@/modules/Satisfaction/store';
import DoeModule, { DoeState } from '@/modules/DOE/store';
import ProjetListModule, { ProjetListState } from '@/modules/Common/store';
import EquipementsModule, { EquipementState } from '@/modules/Equipements/store';
import PreavisEquipementModule from '@/modules/PreavisIntervention/store/modules/PreavisEquipement';
import { EquipementState as PreavisEquipementState } from '@/modules/Intervention/store/modules/Equipement';
import PreavisSiteListModule from '@/modules/PreavisIntervention/store/modules/PreavisSiteList';
import ReglesGestionModule, { ReglesGestionState } from '@/modules/ReglesGestion/store';

export interface RootState {
    authState: AuthState;
    homeState: HomeModuleState;
    demandeDevisState: EstimateRequestState;
    errorToaster: ErrorToasterState;
    siteList: SiteListState;
    demandeInterventionModuleState: DemandeInterventionState;
    suiviDemandeInterventionModuleState: SuiviDemandeInterventionState;
    suiviInterventionModuleState: SuiviInterventionState;
    suiviInterventionPreventiveModuleState: SuiviInterventionPreventiveState;
    demandeDevisModuleState: DemandeDevisState;
    devisModuleState: SuiviDevisState;
    suiviFacturesModuleState: SuiviFacturesModuleState;
    suiviReclamation: SuiviReclamationState;
    preventif: PreventifModuleState;
    accountState: AccountState;
    contactState: ContactState;
    documentReglementaireState: DocumentReglementaireState;
    optionsSuiviInterventionState: OptionsSuiviInterventionState;
    preavisInterventionState: PreavisInterventionState;
    monCompteState: MonCompteState;
    rapportASignerState: RapportASignerState;
    successToaster: SuccessToasterState;
    NFCState: NFCState;
    rapportState: RapportState;
    compteurState: CompteurState;
    authenticationState: AuthenticationState;
    noteReclamationState: NoteReclamationState;
    menuState: MenuState;
    dashboardFournisseurState: DashboardFournisseurState;
    factureFournisseurState: FactureFournisseurState;
    satisfactionState: SatisfactionState;
    reglementFournisseurState: ReglementFournisseurState;
    doeState: DoeState;
    projetListState: ProjetListState;
    equipementState: EquipementState;
    preavisEquipementModule: PreavisEquipementState;
    preavisSiteList: SiteListState;
    reglesGestionState: ReglesGestionState;
}

export const store = createStore({
    modules: {
        authState: AuthModule,
        homeState: HomeModule,
        demandeDevisState: EstimateModule,
        errorToaster: ErrorToasterModule,
        siteList: SiteListModule,
        demandeInterventionModuleState: InterventionModule,
        suiviDemandeInterventionModuleState: DemandeInterventionModule,
        suiviInterventionModuleState: SuiviInterventionModule,
        suiviInterventionPreventiveModuleState: SuiviInterventionPreventiveModule,
        demandeDevisModuleState: DemandeDevisModule,
        devisModuleState: DevisModule,
        suiviFacturesModuleState: SuiviFacturesModule,
        suiviReclamationModule: SuiviReclamationModule,
        preventif: PreventifModule,
        accountModule: AccountModule,
        contactState: ContactModule,
        documentReglementaireState: DocumentReglementaireModule,
        optionsSuiviInterventionState: OptionsSuiviInterventionModule,
        preavisInterventionState: PreavisInterventionModule,
        monCompteState: MonCompteModule,
        NFCState: NFCModule,
        rapportASignerState: RapportASignerModule,
        successToaster: SuccessToasterModule,
        rapportState: RapportModule,
        compteurState: CompteurModule,
        authenticationState: AuthenticationModule,
        noteReclamationState: NoteReclamationModule,
        menuState: MenuModule,
        dashboardFournisseurState: DashboardModule,
        factureFournisseurState: FactureFournisseurModule,
        reglementFournisseurState: ReglementFournisseurModule,
        satisfactionState: SatisfactionModule,
        doeState: DoeModule,
        projetListState: ProjetListModule,
        equipementState: EquipementsModule,
        preavisEquipementModule: PreavisEquipementModule,
        preavisSiteList: PreavisSiteListModule,
        reglesGestionState: ReglesGestionModule,
    },
});
